// common-methods.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root' // This makes it available app-wide
})

export class CommonMethods { 
  constructor() {
  }

  escapeSpecialCharacters(input: string): string {
    let inputText = input;
    let specialCharArray = [
      { 'Character': '!', 'Code': 'U0021' },
      { 'Character': '#', 'Code': 'U0023' },
      { 'Character': '$', 'Code': 'U0024' },
      { 'Character': '%', 'Code': 'U0025' },
      { 'Character': '&', 'Code': 'U0026' },
      { 'Character': '(', 'Code': 'U0028' },
      { 'Character': ')', 'Code': 'U0029' },
      { 'Character': '*', 'Code': 'U002A' },
      { 'Character': '+', 'Code': 'U002B' },
      { 'Character': '-', 'Code': 'U002D' },
      { 'Character': '/', 'Code': 'U002F' },
      { 'Character': '?', 'Code': 'U003F' },
      { 'Character': '@', 'Code': 'U0040' },
      { 'Character': '\\', 'Code': 'U005C' },
      { 'Character': '=', 'Code': 'U003D' },
      { 'Character': '_', 'Code': 'U005F' }
    ];
    let charArray = Array.from(inputText);
    let stringArray = [];
    for (let objChar of charArray) {
      let obj = specialCharArray.find(x => x.Character == objChar);
      stringArray.push(obj == undefined ? objChar : obj.Code);
    }
    inputText = stringArray.join('');
    return inputText;
  }

   static isEmpty(value: string | null | undefined): boolean {
  return value == null || value.trim().length === 0;
}

   static evaluateConditions(...conditions: (() => boolean)[]): boolean {
  return conditions.every(condition => condition());
}

  static checkTextChanged(current?: string, defaultValue?: string): boolean {
  return this.evaluateConditions(
    () => !this.isEmpty(current),
    () => current !== defaultValue
  );
}
}


